// Why the Simulate button cannot be used, as the translation key of the
// tooltip that tells the planner so. A greyed-out button on its own reads the
// same whether the roster is still on its way or never arrived.
export type SimulationUnavailableReason =
  | 'simulation-resources-load-error'
  | 'simulation-resources-loading'
  | 'simulation-no-templates';

export interface SimulationAvailability {
  isStaffLoaded: boolean;
  staffLoadError: string | null;
  isPatientRoomsLoaded: boolean;
  patientRoomsLoadError: string | null;
  templateCount: number;
}

// An error only counts while its resource is missing: the staff slice keeps
// its last error after a later load has succeeded.
export function hasSimulationResourcesLoadError(availability: SimulationAvailability): boolean {
  return (
    (!availability.isStaffLoaded && availability.staffLoadError !== null) ||
    (!availability.isPatientRoomsLoaded && availability.patientRoomsLoadError !== null)
  );
}

// Null when the simulation can be opened.
export function getSimulationUnavailableReason(
  availability: SimulationAvailability
): SimulationUnavailableReason | null {
  if (hasSimulationResourcesLoadError(availability)) return 'simulation-resources-load-error';
  if (!availability.isStaffLoaded || !availability.isPatientRoomsLoaded) {
    return 'simulation-resources-loading';
  }
  if (availability.templateCount === 0) return 'simulation-no-templates';
  return null;
}
